import { Component, OnInit } from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {IDepartment} from "../models/departement";
import {Observable} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {DepartementStoreService} from "../services/departement-store.service";

@Component({
    selector: 'app-department',
    templateUrl: './department.component.html',
    styleUrls: ['./department.component.css'],
    standalone: false
})
export class DepartmentComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private departementStore: DepartementStoreService
  ) { }

  departements : IDepartment[] = [];
  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;

  departements$ : Observable<IDepartment[]> =
    this.departementStore.departements$;

  ngOnInit(): void {
    this.initDepartementChanges();
    this.departements = this.route.snapshot.data.departements as IDepartment[];
  }

  // TODO: redo data handling so this is not needed
  initDepartementChanges(){
    this.departements$.subscribe(
      departments =>{
        this.departements = departments;
      }
    )
  }

  addHandler({ sender }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, Validators.required),
      schedulerColor: new UntypedFormControl(null, Validators.required),
    });

    sender.addRow(this.formGroup);
  }

  editHandler({ sender, rowIndex, dataItem }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(dataItem.name, Validators.required),
      schedulerColor: new UntypedFormControl(dataItem.schedulerColor, Validators.required),
    });

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler(event) {
    const request: any = {
      name: event.formGroup.value.name,
      schedulerColor: event.formGroup.value.schedulerColor,
      id: event.dataItem.id ?? null,
    }
    if (!event.dataItem.id){
      this.departementStore.addDepartement(request);
    } else {
      this.departementStore.updateDepartement(request);
    }

    event.sender.closeRow(event.rowIndex);
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  deletionDialogOpened = false;
  private itemToDelete: { id: string } | null = null;

  public removeHandler({ dataItem }) {
    this.itemToDelete = dataItem;
    this.deletionDialogOpened = true;
  }

  public deleteConfirmed() {
    const dataItem = this.itemToDelete;
    this.itemToDelete = null;
    if (!dataItem) return;
    this.departementStore.deleteDepartement(dataItem.id);
  }
}
